export const FETCH_ADMIN_UI_SET = "FETCH_ADMIN_UI_SET";
